import { SharedConstants } from "../../../constants/shared.constants";
export class RecipientSelectConstants {
    // Form labels
    static nameLabel = "Name";
    static surnameLabel = "Surname";
    static homeTelePhoneLabel = "Home telephone";
    static workTelephoneLabel = "Work telephone";
    static cellphoneLabel = "Cellphone";
    static defaultCommunicationMethodLabel = "Preferred method of communication";
    static emailRadioButtonLabel = "Email";
    static smsRadioButtonLabel = "SMS";
    static emailLabel = "Email";
    static passportNumberLabel = "Passport number";
    static genderLabel = "Gender";
    static disabilityLabel = "Disability";
    static organisationLabel = "Organisation";
    static clientVatNumberLabel = "Client VAT number";
    static designationLabel = "Designation";
    static professionalBodyHeader = "Professional body details";
    static professionalBodyLabel = "Professional body";
    static relativeDetailsBodyLabel = "Relative's details";
    static employerDetailsHeader = "Employer's details";
    static maritalStatusLabel = "Marital status";
    static idNumberLabel = "ID Number";
    static relativesFullNameLabel = "Relative's full name";
    static relativesContactNumberLabel = "Relative's contact number";
    static relativesAddressLabel = "Relative's address";
    static employmentStatusLabel = "Employment status";
    static employersNameLabel = "Employer's name";
    static employersContactNumberLabel = "Employer's contact number";
    static employersAddressLabel = "Employer's address";
    static professionalBodyRegNoLabel = "Professional body registration number";
    static streetAddressHeader = "Street address details";
    static streetAddressLabel = "Street address";
    static streetSuburbLabel = "Suburb";
    static streetCityLabel = "City";
    static streetProvinceLabel = "Province";
    static streetCountryLabel = "Country";
    static streetCodeLabel = "Code";
    static postalAddressLabel = "Postal address";
    static postalSuburbLabel = "Suburb";
    static postalCityLabel = "City";
    static postalProvinceLabel = "Province";
    static postalCountryLabel = "Country";
    static postalCodeLabel = "Code";
    static postalDetailsHeader = "Postal address details";
    static sameAsStreetAddressLabel = "Same as street address";
    static groups = "Group Details";
    static groupsLabel = "Groups";
    static selectGroupsLabel = "Select group(s)";
    static requireFieldKey = "requiredFields";
    static sacapRegistrationLabel = "SACAP registration number";
    static sacapVerificationButtonLabel = "Verify with SACAP";
    static sacapRegistrationHeader = "SACAP verification";
    static PLEASE_SELECT_AN_OPTION = "Please select an option";
    // Form Controls
    static idFormControlName = "id";
    static jobIdFormControlName = "jobId";
    static moduleIdFormControlName = "moduleId";
    static nameFormControl = "name";
    static surnameFormControl = "surname";
    static homeTelePhoneFormControl = "homePhone";
    static workTelephoneFormControl = "telephone";
    static cellphoneFormControlName = "cellphone";
    static defaultCommunicationMethodFormControlName = "defaultCommunicationMethod";
    static emailFormControlName = "email";
    static passportNumberFormControlName = "passportNumber";
    static genderFormControlName = "gender";
    static disabilityFormControlName = "disability";
    static organisationFormControlName = "organisation";
    static clientVatNumberFormControlName = "clientVatNumber";
    static designationFormControlName = "designation";
    static professionalBodyFormControlName = "professionalBody";
    static professionalBodyRegNoFormControlName = "professionalBodyRegNum";
    static maritalStatusFormControlName = "maritalStatus";
    static idNumberFormControlName = "idNumber";
    static relativesFullNameFormControlName = "relativesFullName";
    static relativesContactNumberFormControlName = "relativesContactNumber";
    static relativesAddressFormControlName = "relativesAddress";
    static employmentStatusFormControlName = "employmentStatus";
    static employersNameFormControlName = "employersName";
    static employersContactNumberFormControlName = "employersContactNumber";
    static employersAddressFormControlName = "employersAddress";
    static streetAddressFormControlName = "streetAddress";
    static streetSuburbFormControlName = "streetSuburb";
    static streetCityFormControlName = "streetCity";
    static streetProvinceFormControlName = "streetProvince";
    static streetCountryFormControlName = "streetCountry";
    static streetCodeFormControlName = "streetCode";
    static postalAddressFormControlName = "postalAddress";
    static postalSuburbFormControlName = "postalSuburb";
    static postalCityFormControlName = "postalCity";
    static postalProvinceFormControlName = "postalProvince";
    static postalCountryFormControlName = "postalCountry";
    static postalCodeFormControlName = "postalCode";
    static groupsFormControlName = "groups";
    static groupsStringArrayFormControlName = "groupsStringArray";
    static defaultComponentName = "recipient-select";
    static sacapRegistrationNumberFormControl = "sacapRegistrationNumber";
    static sacapRegistrationNumberVerifiedFormControl = "sacapRegistrationNumberVerified";
    static MISSING_LOOKUPS = "Lookups not found or not set";
    // Validation Messages
    static validationMessage = {
        name: {
            name: "Please enter name",
            maxlength: `Name ${SharedConstants.MAX_LENGTH_INPUT_CONTROL_VALIDATION.replace("yyy", "50")}`,
        },
        surname: {
            surname: "Please enter surname.",
            maxlength: `Surname ${SharedConstants.MAX_LENGTH_INPUT_CONTROL_VALIDATION.replace("yyy", "50")}`,
        },
        telephone: {
            telephone: "Please enter a valid phone number in the format +27123457788.",
            maxlength: `Telephone ${SharedConstants.MAX_LENGTH_INPUT_CONTROL_VALIDATION.replace("yyy", "20")}`,
        },
        homePhone: {
            homePhone: "Please enter a valid phone number in the format +27123457788.",
            maxlength: `Homephone ${SharedConstants.MAX_LENGTH_INPUT_CONTROL_VALIDATION.replace("yyy", "20")}`,
        },
        cellphone: {
            cellphone: "Please enter a valid phone number in the format +27123457788.",
            maxlength: `Cellphone ${SharedConstants.MAX_LENGTH_INPUT_CONTROL_VALIDATION.replace("yyy", "20")}`,
        },
        organisation: {
            organisation: "Please enter organisation name.",
            maxlength: `Organisation ${SharedConstants.MAX_LENGTH_INPUT_CONTROL_VALIDATION.replace("yyy", "250")}`,
        },
        gender: {
            gender: "Please select a gender.",
        },
        disabled: {
            disabled: "Please select your disability status.",
        },
        passportNumber: {
            passportNumber: "Please enter your passport number.",
        },
        clientVatNumber: {
            clientVatNumber: "Please enter the client's vat number.",
            maxlength: `Client Vat Number ${SharedConstants.MAX_LENGTH_INPUT_CONTROL_VALIDATION.replace("yyy", "100")}`,
        },
        designation: {
            designation: "Please enter designation.",
            maxlength: `Designation ${SharedConstants.MAX_LENGTH_INPUT_CONTROL_VALIDATION.replace("yyy", "250")}`,
        },
        professionalBody: {
            professionalBody: "Please enter professional body.",
            maxlength: `Professional body ${SharedConstants.MAX_LENGTH_INPUT_CONTROL_VALIDATION.replace("yyy", "500")}`,
        },
        professionalBodyRegNum: {
            professionalBodyRegNum: "Please enter the professional body's registration number.",
            maxlength: `Professional body Registration number ${SharedConstants.MAX_LENGTH_INPUT_CONTROL_VALIDATION.replace("yyy", "100")}`,
        },
        maritalStatus: {
            maritalStatus: "Please select your marital status.",
        },
        idNumber: {
            idNumber: "Please enter your ID number.",
            maxlength: `ID number ${SharedConstants.MAX_LENGTH_INPUT_CONTROL_VALIDATION.replace("yyy", "50")}`,
        },
        relativesFullName: {
            relativesFullName: "Please enter your relative's full name.",
        },
        relativesContactNumber: {
            relativesContactNumber: "Please enter your relative's contact number.",
        },
        relativesAddress: {
            relativesAddress: "Please enter your relative's address.",
        },
        employmentStatus: {
            employmentStatus: "Please select your employment status.",
        },
        employersName: {
            employersName: "Please enter your employer's name.",
        },
        employersContactNumber: {
            employersContactNumber: "Please enter your employer's number.",
        },
        employersAddress: {
            employersAddress: "Please enter your employer's address.",
        },
        email: {
            email: "Please enter a valid email address, for example, JDoe@gmail.com.",
            maxlength: `Email ${SharedConstants.MAX_LENGTH_INPUT_CONTROL_VALIDATION.replace("yyy", "250")}`,
        },
        streetAddress: {
            streetAddress: "Please enter address.",
            maxlength: `Street address ${SharedConstants.MAX_LENGTH_INPUT_CONTROL_VALIDATION.replace("yyy", "250")}`,
        },
        streetSuburb: {
            streetSuburb: "Please enter suburb.",
            maxlength: `Street suburb ${SharedConstants.MAX_LENGTH_INPUT_CONTROL_VALIDATION.replace("yyy", "100")}`,
        },
        streetCity: {
            streetCity: "Please enter city.",
            maxlength: `Street City ${SharedConstants.MAX_LENGTH_INPUT_CONTROL_VALIDATION.replace("yyy", "50")}`,
        },
        streetProvince: {
            streetProvince: "Please select a province.",
            maxlength: `Street Country ${SharedConstants.MAX_LENGTH_INPUT_CONTROL_VALIDATION.replace("yyy", "50")}`,
        },
        streetCountry: {
            streetCountry: "Please select a country.",
            maxlength: `Country ${SharedConstants.MAX_LENGTH_INPUT_CONTROL_VALIDATION.replace("yyy", "50")}`,
        },
        streetCode: {
            streetCode: "Please enter a street code.",
            maxlength: `Street Code ${SharedConstants.MAX_LENGTH_INPUT_CONTROL_VALIDATION.replace("yyy", "50")}`,
        },
        postalAddress: {
            postalAddress: "Please enter a postal address.",
            maxlength: `Postal Address ${SharedConstants.MAX_LENGTH_INPUT_CONTROL_VALIDATION.replace("yyy", "250")}`,
        },
        postalSuburb: {
            postalSuburb: "Please enter suburb.",
            maxlength: `Postal Suburb ${SharedConstants.MAX_LENGTH_INPUT_CONTROL_VALIDATION.replace("yyy", "100")}`,
        },
        postalCity: {
            postalCity: "Please enter a city.",
            maxlength: `Postal City ${SharedConstants.MAX_LENGTH_INPUT_CONTROL_VALIDATION.replace("yyy", "50")}`,
        },
        postalProvince: {
            postalProvince: "Please select a province.",
            maxlength: `Postal Province ${SharedConstants.MAX_LENGTH_INPUT_CONTROL_VALIDATION.replace("yyy", "50")}`,
        },
        postalCountry: {
            postalCountry: "Please select a country.",
            maxlength: `Postal Country ${SharedConstants.MAX_LENGTH_INPUT_CONTROL_VALIDATION.replace("yyy", "50")}`,
        },
        postalCode: {
            postalCode: "Please enter a postal code.",
            maxlength: `Postal Code ${SharedConstants.MAX_LENGTH_INPUT_CONTROL_VALIDATION.replace("yyy", "50")}`,
        },
        groups: "Please select a group.",
        sacapRegistrationNumber: "Please enter registration number.",
    };
    // Error messages
    static metadataPropertyNotSetErrMsg = "property is not set in the recipient metadata, please contact your system administrator.";
}
